<template>
<span id="re-run-rating" v-if="isVisible()">
  <el-button id="btn-re-run-rating" type="success" plain @click="reRunRating()" size="mini">{{ $t('customerService.shipment.reRate') }}</el-button>
</span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'ReRunRating',
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    },
    shipmentNonRevenue: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    isVisible() {
      const hasShipmentStatusErrorMasterOrRated = this.shipmentStatus === constants.SHIPMENT.STATUS[2].value || this.shipmentStatus === constants.SHIPMENT.STATUS[3].value || this.shipmentStatus === constants.SHIPMENT.STATUS[4].value;
      const hasEditRatingPermission = this.$can(this.permissions.BILLING.EDIT_RATING);
      return hasShipmentStatusErrorMasterOrRated && hasEditRatingPermission && !this.shipmentNonRevenue;
    },
    async reRunRating() {
      const confirmReRate = await this.$confirm(
        this.$t('customerService.shipment.reRateConfirm'),
        { confirmButtonText: this.$t('customerService.shipment.reRateConfirmButton'), dangerouslyUseHTMLString: true }
      ).catch(() => {});

      if (confirmReRate) {
        const loading = this.$loading(constants.LOADING.RUN_RATING_CONFIG);
        try {
          const response = await this.$store.dispatch('shipment/reRunRating', this.shipmentId).catch(() => {});
          this.$message.success(response.message);
          this.$store.dispatch('shipment/searchHeader', this.shipmentId);
          this.$store.dispatch('shipment/searchRatings', {
            shipmentId: this.shipmentId,
            page: constants.TABLES.DEFAULT_PAGE,
            rows: constants.TABLES.DEFAULT_LIMIT,
            pageResults: true
          });
        } finally {
          loading.close();
        }
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#re-run-rating {
  float: right;
  margin-right: 10px;
}
</style>
